import barY from "../../../assets/images/bar_y.webp"
import barB from "../../../assets/images/bar_b.webp"

import s from './ProgressBar.module.css'

interface ProgressBarProps {
    current: number;
    max: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ current, max }) => {
    const progressArray = Array.from({ length: max }, (_, index) =>
        index < current ? barY : barB
    );
    return (
        <div className={s.barContainer}>
            {progressArray.map((imgSrc, index) => (
                <img
                    key={index}
                    className={s.bar}
                    src={imgSrc}
                    alt={index < current ? 'Completed' : 'Not completed'}
                />
            ))}
        </div>
    )
    // return (
    //     <div className={`${s.barContainer} ${s.barProgress}`}>
    //         <div className={`${s.barContainer} ${s.barComplete}`}
    //             style={{ width: `${completeWidth(current, max)}vw` }}
    //         >
    //             <p className={s.mainText}>{current} / {max}</p>
    //         </div>
    //     </div>
    // )
}

export default ProgressBar